
const breakPoints = {
    xs: {
        max: 575
    }
    ,
    sm: {
        min: 576,
        max: 767
    }
    ,
    md: {
        min: 768,
        max: 1024
    }
    ,
    lg: {
        min: 1025,
        max: 1279
    }
    ,
    xl: {
        min: 1280
    }
}

export default {
    data: () => {
        return {
            windowWidth: 0,
            windowHeight: 0,
            xs: false,
            sm: false,
            md: false,
            lg: false,
            xl: false,
            isMobile: false,
            isTablet: false,
            isDesktop: false,
        }
    },
    created() {
        window.addEventListener('resize', this.getWindowWidth);
        window.addEventListener('resize', this.getWindowHeight);
        this.getWindowWidth()
        this.getWindowHeight()
        /*this.$nextTick(function () {

        })*/
    },
    methods: {
        getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
            this.xs = this.windowWidth <= breakPoints.xs.max;
            this.sm = this.windowWidth >= breakPoints.sm.min && this.windowWidth <= breakPoints.sm.max;
            this.md = this.windowWidth >= breakPoints.md.min && this.windowWidth <= breakPoints.md.max;
            this.lg = this.windowWidth >= breakPoints.lg.min && this.windowWidth <= breakPoints.lg.max;
            this.xl = this.windowWidth >= breakPoints.xl.min;
            if (this.xs || this.sm) {
                this.isMobile = true;
            } else if (this.md) {
                this.isTablet = true;
            } else if (this.lg || this.xl) {
                this.isDesktop = true;
            }
        },

        getWindowHeight() {
            this.windowHeight = document.documentElement.clientHeight;
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
        window.removeEventListener('resize', this.getWindowHeight);
    }
}
